import styled from "styled-components";

export const EtiquetaAzulBusquedaContainer = styled.div`
  background-color: var(--color-latex30);
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 26px;
  width: max-content;
  padding: 0 20px;
  cursor: pointer;
`;
export const EtiquetaAzulBusquedaBody = styled.div`
  display: flex;
  ${({ fullStr }) => !fullStr && `max-width: 378px;`};
  align-items: center;
  justify-content: center;
  gap: 12px;
  span {
    color: var(--color-white);
    ${({ fullStr }) =>
      !fullStr &&
      `white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;`}
  }
`;
